module.exports = __webpack_public_path__ + "14704cfae85af348c47ccca92e8864e0.pdf";